export default __webpack_public_path__ + "static/media/sorting.c485af6a.svg";